<!--https://material.io/resources/icons/?icon=accessible&style=baseline-->

<template>
  <div id="app" class="heebo-font">
    <link href="https://fonts.googleapis.com/css?family=Roboto" rel="stylesheet">
    <v-app id="inspire">
      <v-navigation-drawer
              v-model="drawer"
              fixed
              right
              app
      >
        <v-list dense>


          <div class="body-1 text-xs-center red--text text--lighten-1 pb-2 pt-1 rtl">
            היי
            {{ $user.email || 'אורח' }}
          </div>
          <hr>
          <div class="subheading text-xs-center red--text lighten-2">כללי</div>
          <hr>

          <router-link v-if="$user.email == 'sendi@sendi.sendi'" class="router-link" tag="li" to="/home">
            <v-list-tile >
              <v-list-tile-action>
                <v-icon>home</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Home</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </router-link>


          <router-link v-if="$user.email == 'sendi@sendi.sendi'" class="router-link" tag="li" to="/system/settings">
            <v-list-tile >
              <v-list-tile-action>
                <v-icon>settings</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>הגדרות מערכת</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </router-link>

          <br v-if="$user.email == 'sendi@sendi.sendi'">
          <hr v-if="$user.email == 'sendi@sendi.sendi'">
          <div v-if="$user.email == 'sendi@sendi.sendi'" class="subheading text-xs-center red--text lighten-2">סנדי</div>
          <hr v-if="$user.email == 'sendi@sendi.sendi'">

          <router-link v-if="$user.email == 'sendi@sendi.sendi'" class="router-link" tag="li" to="/screen/settings">
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>settings</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>סנדי - הגדרות מסכים</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </router-link>

          <router-link v-if="$user.email == 'sendi@sendi.sendi'" class="router-link" tag="li" to="/screen/style">
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>settings</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>עיצוב דינמי למסכים</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </router-link>

          <router-link v-if="$user.email == 'sendi@sendi.sendi'" class="router-link" tag="li" to="/screen/buttons">
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>settings</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>הגדרות כפתורים למסכים</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </router-link>

          <router-link v-if="$user.email == 'sendi@sendi.sendi'" class="router-link" tag="li" to="/sms/settings">
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>send</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>הגדרות sms</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </router-link>

          <router-link v-if="$user.email == 'sendi@sendi.sendi'" class="router-link" tag="li" to="/entering-values">
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>done</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>הזנת ערכים לסנדי</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </router-link>

          <router-link v-if="$user.email == 'sendi@sendi.sendi'" class="router-link" tag="li" to="/insert">
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>blur_off</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>חוסרים</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </router-link>

          <router-link v-if="$user.email == 'sendi@sendi.sendi'" class="router-link" tag="li" to="/whatsapp">
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>question_answer</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>WhatsApp</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </router-link>

          <!--<router-link class="router-link" tag="li" to="/screen/style" v-if="$user.email == 'sendi@sendi.sendi'">
            <v-list-tile >
              <v-list-tile-action>
                <v-icon>settings</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>הגדרות עיצוב</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </router-link>-->

<!--          <router-link v-if="$user.email == 'sendi@sendi.sendi'" class="router-link" tag="li" to="/sendi/upload">
            <v-list-tile >
              <v-list-tile-action>
                <v-icon>search</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>סנדי - העלאה</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </router-link>-->


          <br v-if="$user.email == 'sendi@sendi.sendi'">
<!--
          <hr v-if="$user.email == 'sendi@sendi.sendi'">
          <div v-if="$user.email == 'sendi@sendi.sendi'" class="subheading text-xs-center red&#45;&#45;text lighten-2">מנדי</div>
          <hr v-if="$user.email == 'sendi@sendi.sendi'">

          <router-link v-if="$user.email == 'sendi@sendi.sendi'" class="router-link" tag="li" to="/mendi/upload">
            <v-list-tile >
              <v-list-tile-action>
                <v-icon>search</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>מנדי - העלאה</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </router-link>

          <router-link class="router-link" tag="li" to="/mendi/search">
            <v-list-tile >
              <v-list-tile-action>
                <v-icon>search</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>מנדי - חיפוש</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </router-link>

          <router-link v-if="$user.email == 'sendi@sendi.sendi'" class="router-link" tag="li" to="/mendi/statistics">
            <v-list-tile >
              <v-list-tile-action>
                <v-icon>visibility</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>מנדי - סטטיסטיקות</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </router-link>
-->


          <hr>
          <div class="subheading text-xs-center red--text lighten-2">פרופיל</div>
          <hr>

          <router-link v-if="!$user.email" class="router-link" tag="li" to="/login">
            <v-list-tile >
              <v-list-tile-action>
                <v-icon>contact_mail</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Login</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </router-link>

          <li style="cursor: pointer" @click="logout()" v-if="$user.id">
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>directions_walk</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Logout</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </li>

        </v-list>
      </v-navigation-drawer>
      <v-toolbar color="blue lighten-1" dark fixed app>

        <v-img :src="require('@/assets/logo.png')" position="center left" :contain="true" height="50"></v-img>
        <v-toolbar-title>Sendi cloud ענן</v-toolbar-title>
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      </v-toolbar>
      <router-view :loading.sync="loading"
                   :snackbar.sync="snackbar">
      </router-view>
      <loader :loading.sync="loading" ></loader>

      <v-footer color="blue lighten-1" app>
        <v-spacer></v-spacer>
        <span class="white--text">&copy; 2017 </span>
      </v-footer>
    </v-app>
    <v-snackbar
            v-model="snackbar.show"
            :bottom="false"
            :left="true"
            :timeout="1000"
            :top="true"
            :vertical="true"
    >
      {{ snackbar.text }}
      <v-btn
              color="pink"
              flat
              @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>

const moment = require('moment-timezone');
const q = require('q');
import Login from './components/Login.vue'
import Loader from './components/Loader.vue'
// import Upload from './components/Upload.vue'

export default {
    data: () => ({
        drawer: null,
        loading: true,
        $user : {},
        snackbar: {
            show : false,
            text : ''
        },
        socketRequests : {},
    }),
    props: {
        source: String
    },

    name: 'app',
    components: {
      Login,
      Loader,
      // Upload
    },
    methods: {
      logout() {
        fetch(this.$server_api_url + '/logout')
                .then(async(response) => {
                  // log(await response.json());

                  this.$user = {};
                  this.$emit('update:$user', {});
                  this.$router.push({ path: `/login`} )
                })
      }


    },

    created() {
        /*this.$socket.emit('sum.event', {
            data : 'sum data'
        });*/




        /*this.req('sum.event', {
            data : 'sum data aaaaaaaaaaa'
        }).then(data => {
            log('Socket res ->', data)
        });*/

    },
    beforeRouteLeave(to, from, next) {

        next();
    },
    /*sockets : {
        connect: function() {
            log('socket connect');

            this.$SocketInstance.on('*', (data) => {

                log("111111111111111", data)
            })
        },


        mgs: function (data) {
            log('Socket msg ->', data)
        },
        '*' : function (data) {
            log('Socket msg ->', data)
        }

    }*/
}
</script>

<style>
  /*!* hebrew *!
  @font-face {
    font-family: 'Heebo' !important;
    font-style: normal;
    font-weight: 400;
    src: local('Heebo'), local('Heebo-Regular'), url(https://fonts.gstatic.com/s/heebo/v3/NGS6v5_NC0k9P9H0TbFzsQ.woff2) format('woff2');
    unicode-range: U+0590-05FF, U+20AA, U+25CC, U+FB1D-FB4F;
  }*/

  @import url('https://fonts.googleapis.com/css?family=Heebo');


  .router-link {
    cursor: pointer;
  }
  .heebo-font div {
    font-family: Heebo, sans-serif !important;
  }
  .rtl {
    direction: rtl;
  }
  .ltr {
    direction: ltr;
  }
  .display-4 ,.display-3 ,.display-2 ,.display-1 ,.headline ,.title ,.subheading ,.body-2 ,.body-1 ,.caption ,.font-weight-thin ,.font-weight-light ,.font-weight-regular ,.font-weight-medium ,.font-weight-bold ,.font-weight-black ,.font-weight-thin.font-italic ,.font-weight-light.font-italic ,.font-weight-regular.font-italic ,.font-weight-medium.font-italic ,.font-weight-bold.font-italic ,.font-weight-black.font-italic {
    font-family: Heebo, sans-serif !important;
    text-align: right;
  }

  a.router-link {
    text-decoration: none;
  }


</style>
